export default "__VITE_ASSET__1fnheDYS__"